import { snakeToCamel } from '../../../utils/object'

import Model from '../models'
import Tag from '@/services/tags/'
import Preference from '@/services/preferences/'
import Application from '@/services/applications/'
import Evaluation from '@/services/evaluations/'
import Organization from '@/services/organizations'

import axios from 'axios'

import UserAPI from './api'

export default class User extends Model {
  static api = UserAPI.create(User)
  static readOnlyFields = ['id', 'fullName', 'token', 'tagsRef']

  static evaluatorStatuses = {
    ACTIVE: 'Active',
    CANCELED: 'Canceled',
    TARGET: 'Target',
    APPLIED: 'Applied',
    SHOWED_INTEREST: 'Showed Interest',
    CONFIRMED: 'Confirmed',
    SNOOZED: 'Snoozed',
  }

  constructor({
    id = null,
    email = '',
    tags = [],
    tagsRef = [],
    firstName = '',
    lastName = '',
    fullName = '',
    notes = '',
    status = 'ACTIVE',
    preferences = [],
    preferencesRef = [],
    isStaff = false,
    isEvaluator = false,
    pendingAsEvaluator = true,
    rejectedAsEvaluator = false,
    assignments = [],
    currentAssignments = [],
    evaluations = [],
    currentEvaluations = [],
    token = null,
    automaticEmailSent = false,
    manualEmailSent = false,
    emailToSend = 'ONBOARDED',
    evaluatorWhyJoin = '',
    evaluatorAffiliation = '',
    evaluatorOtherAffiliations = '',
    evaluatorQualifications = '',
    evaluatorHowFindOut = '',
    evaluatorMainInterests = '',
    organization = null,
    organizationRef = null,
    emailRecords = [],
    linkedinProfile = '',
    dateJoined = '',
  } = {}) {
    super()
    Object.assign(this, {
      id,
      email,
      tags,
      tagsRef,
      preferences,
      preferencesRef,
      firstName,
      lastName,
      notes,
      status,
      fullName,
      isStaff,
      isEvaluator,
      pendingAsEvaluator,
      rejectedAsEvaluator,
      assignments,
      currentAssignments: currentAssignments.map(Application.fromAPI),
      evaluations,
      currentEvaluations: currentEvaluations.map(Evaluation.fromAPI),
      token,
      automaticEmailSent,
      manualEmailSent,
      emailToSend,
      evaluatorAffiliation,
      evaluatorOtherAffiliations,
      evaluatorWhyJoin,
      evaluatorQualifications,
      evaluatorHowFindOut,
      evaluatorMainInterests,
      organization,
      organizationRef: Organization.fromAPI(organizationRef),
      emailRecords,
      linkedinProfile,
      dateJoined,
    })
  }

  static create(opts = {}) {
    if (opts.tags_ref) {
      opts.tags_ref = opts.tags_ref.map(Tag.create)
    }
    if (opts.preferences_ref) {
      opts.preferences_reef = opts.preferences_ref.map(Preference.create)
    }
    return new User(opts)
  }

  static fromAPI(json = {}) {
    const jsonCamel = snakeToCamel(json)
    if (jsonCamel.tags_ref) {
      jsonCamel.tags_ref = jsonCamel.tags_ref.map(Tag.fromAPI)
    }
    if (jsonCamel.preferences_ref) {
      jsonCamel.preferences_ref = jsonCamel.preferences_ref.map(Preference.fromAPI)
    }
    return new User(jsonCamel)
  }

  copy() {
    return new User(this)
  }
}

export function validateToken(token) {
  const endpoint = '/api/validate-token/'
  const params = { token }
  const options = {
    headers: {
      'Content-Type': 'application/json',
    },
  }
  const promise = axios.post(endpoint, params, options)
  return promise
    .then(response => response.data)
    .catch(error => {
      // eslint-disable-next-line no-console
      console.log('Validate Token API error')
      throw error
    })
}
